{
  "INBOX_MGMT": {
    "HEADER": "Posteingänge",
    "DESCRIPTION": "A channel is the mode of communication your customer chooses to interact with you. An inbox is where you manage interactions for a specific channel. It can include communications from various sources such as email, live chat, and social media.",
    "LEARN_MORE": "Mehr über Posteingänge erfahren",
    "RECONNECT": {
      "BUTTON": "Neu verbinden",
      "FACEBOOK": "Die Verbindung zu Facebook ist abgelaufen oder wurde widerrufen. Nachrichten an die Seite kommen nicht in diesem Posteingang an, und Antworten können fehlschlagen. Eine Person, die die Facebook-Seite verwaltet, muss auf „Neu verbinden“ klicken und sich bei Facebook anmelden.",
      "INSTAGRAM": "Die Verbindung zu Instagram ist abgelaufen oder wurde widerrufen. Nachrichten an das Konto kommen nicht in diesem Posteingang an, und Antworten können fehlschlagen. Klicken Sie auf „Neu verbinden“ und melden Sie sich mit demselben Instagram-Konto an. Ein anderes Konto erstellt einen neuen Posteingang.",
      "GOOGLE": "Die Verbindung zu Google ist abgelaufen oder wurde widerrufen. Neue E-Mails kommen nicht in diesem Posteingang an, und Antworten können fehlschlagen. Klicken Sie auf „Neu verbinden“ und melden Sie sich bei Google als {email} an.",
      "MICROSOFT": "Die Verbindung zu Microsoft ist abgelaufen oder wurde widerrufen. Neue E-Mails kommen nicht in diesem Posteingang an, und Antworten können fehlschlagen. Klicken Sie auf „Neu verbinden“ und melden Sie sich bei Microsoft als {email} an.",
      "ALLEGRO": "Die Verbindung zu Allegro ist abgelaufen oder wurde widerrufen. Nachrichten von Käufern kommen nicht in diesem Posteingang an, und Antworten können fehlschlagen. Klicken Sie auf „Neu verbinden“ und melden Sie sich bei Allegro als Verkäufer {seller} an. Ein anderes Verkäuferkonto erstellt einen neuen Posteingang.",
      "IMAP_LOGIN": "Der Mailserver lehnt die IMAP-Anmeldung als {login} ab. Neue E-Mails erreichen diesen Posteingang nicht. Prüfen Sie den IMAP-Benutzernamen und das Passwort auf dem Tab {tab} und speichern Sie sie. Wir versuchen es weiter, und der Posteingang erholt sich, sobald die Anmeldung funktioniert.",
      "WHATSAPP": "Die Verbindung zu WhatsApp ist abgelaufen oder wurde widerrufen. Anhänge von Kunden erreichen diesen Posteingang nicht, und Antworten können fehlschlagen. Klicken Sie auf Neu verbinden, melden Sie sich bei Facebook an und wählen Sie erneut die Nummer {phone}."
    },
    "LIST": {
      "404": "Diesem Konto sind keine Posteingänge zugeordnet.",
      "RECONNECT_REQUIRED": "Erneute Verbindung erforderlich"
    },
    "CREATE_FLOW": {
      "CHANNEL": {
        "TITLE": "Wählen Sie Kanal",
        "BODY": "Wählen Sie den Anbieter, den Sie in den Chat integrieren möchten."
      },
      "INBOX": {
        "TITLE": "Posteingang erstellen",
        "BODY": "Authentifizieren Sie Ihr Konto und erstellen Sie einen Posteingang."
      },
      "AGENT": {
        "TITLE": "Agenten hinzufügen",
        "BODY": "Fügen Sie dem erstellten Posteingang Agenten hinzu."
      },
      "FINISH": {
        "TITLE": "Voilà!",
        "BODY": "Geschafft!"
      }
    },
    "ADD": {
      "CHANNEL_NAME": {
        "LABEL": "Posteingang-Name",
        "PLACEHOLDER": "Geben Sie den Namen für Ihren Posteingang ein (eg: Acme Inc)",
        "ERROR": "Bitte geben Sie einen gültigen Posteingangsnamen ein"
      },
      "WEBSITE_NAME": {
        "LABEL": "Webseiten-Name",
        "PLACEHOLDER": "Geben Sie den Namen Ihrer Website ein (zum Beispiel: Acme Inc)"
      },
      "FB": {
        "HELP": "PS: Durch die Anmeldung erhalten wir nur Zugriff auf die Nachrichten Ihrer Seite. Auf Ihre privaten Nachrichten können wir niemals zugreifen.",
        "CHOOSE_PAGE": "Seite auswählen",
        "CHOOSE_PLACEHOLDER": "Wähle eine Seite aus der Liste",
        "INBOX_NAME": "Posteingang-Name",
        "ADD_NAME": "Namen für diesen Posteingang eingeben",
        "PICK_NAME": "Wählen Sie einen Namen für Ihren Posteingang aus",
        "PICK_A_VALUE": "Wählen Sie einen Wert aus",
        "CREATE_INBOX": "Posteingang erstellen"
      },
      "TWITTER": {
        "HELP": "Um Ihr Twitter-Profil als Kanal hinzuzufügen, müssen Sie Ihr Twitter-Profil authentifizieren, indem Sie auf 'Mit Twitter anmelden' klicken.",
        "ERROR_MESSAGE": "Beim Verbinden mit Twitter ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
        "TWEETS": {
          "ENABLE": "Konversationen aus erwähnten Tweets erstellen"
        }
      },
      "WEBSITE_CHANNEL": {
        "TITLE": "Website-Kanal",
        "DESC": "Erstellen Sie einen Kanal für Ihre Website und unterstützen Sie Ihre Kunden über unser Website-Widget.",
        "LOADING_MESSAGE": "Website-Support-Channel erstellen",
        "CHANNEL_AVATAR": {
          "LABEL": "Kanal-Avatar"
        },
        "CHANNEL_WEBHOOK_URL": {
          "LABEL": "Webhook-URL",
          "PLACEHOLDER": "Bitte geben Sie Ihre Webhook-URL ein",
          "ERROR": "Bitte geben Sie eine gültige URL ein"
        },
        "CHANNEL_DOMAIN": {
          "LABEL": "Website-Domain",
          "PLACEHOLDER": "Geben Sie Ihre Website-Domain ein (eg: acme.com)"
        },
        "CHANNEL_WELCOME_TITLE": {
          "LABEL": "Willkommens-Überschrift",
          "PLACEHOLDER": "Hallo!"
        },
        "CHANNEL_WELCOME_TAGLINE": {
          "LABEL": "Willkommens-Schlagzeile",
          "PLACEHOLDER": "Wir machen es einfach, sich mit uns zu verbinden. Fragen Sie uns etwas oder teilen Sie uns Ihr Feedback mit."
        },
        "CHANNEL_GREETING_MESSAGE": {
          "LABEL": "Grußnachricht des Kanals",
          "PLACEHOLDER": "Acme Inc antwortet in der Regel innerhalb weniger Stunden."
        },
        "CHANNEL_GREETING_TOGGLE": {
          "LABEL": "Kanal Begrüßung aktivieren",
          "HELP_TEXT": "Automatisch eine Begrüßungsnachricht senden, wenn eine neue Konversation erstellt wird.",
          "ENABLED": "Aktiviert",
          "DISABLED": "Deaktiviert"
        },
        "REPLY_TIME": {
          "TITLE": "Reaktionszeit festlegen",
          "IN_A_FEW_MINUTES": "Innerhalb weniger Minuten",
          "IN_A_FEW_HOURS": "Innerhalb weniger Stunden",
          "IN_A_DAY": "Innerhalb eines Tages",
          "HELP_TEXT": "Diese Antwortzeit wird im Live-Chat-Widget angezeigt"
        },
        "WIDGET_COLOR": {
          "LABEL": "Widget Farbe",
          "PLACEHOLDER": "Aktualisieren Sie die im Widget verwendete Widget-Farbe"
        },
        "SUBMIT_BUTTON": "Posteingang erstellen",
        "API": {
          "ERROR_MESSAGE": "Wir konnten keinen Website-Kanal erstellen, bitte versuchen Sie es erneut"
        }
      },
      "TWILIO": {
        "TITLE": "Twilio SMS/WhatsApp-Kanal",
        "DESC": "Integrieren Sie Twilio und unterstützen Sie Ihre Kunden via SMS oder WhatsApp.",
        "ACCOUNT_SID": {
          "LABEL": "Account SID",
          "PLACEHOLDER": "Bitte geben Sie Ihre Twilio Account SID ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "API_KEY": {
          "USE_API_KEY": "Verwenden Sie die API-Schlüssel-Authentifizierung",
          "LABEL": "API-Schlüssel SID",
          "PLACEHOLDER": "Bitte geben Sie Ihre API-Schlüssel SID ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "API_KEY_SECRET": {
          "LABEL": "API-Schlüssel-Geheimnis",
          "PLACEHOLDER": "Bitte geben Sie Ihr API-Schlüssel-Geheimnis ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "MESSAGING_SERVICE_SID": {
          "LABEL": "Messaging-Dienst-SID",
          "PLACEHOLDER": "Bitte geben Sie Ihre Twilio Messaging Service SID ein",
          "ERROR": "Dieses Feld wird benötigt",
          "USE_MESSAGING_SERVICE": "Verwenden Sie einen Twilio-Nachrichtendienst"
        },
        "CHANNEL_TYPE": {
          "LABEL": "Kanal-Typ",
          "ERROR": "Bitte wählen Sie den Kanal-Typ aus"
        },
        "AUTH_TOKEN": {
          "LABEL": "Auth-Token",
          "PLACEHOLDER": "Bitte geben Sie Ihr Twilio Auth Token ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "CHANNEL_NAME": {
          "LABEL": "Posteingang-Name",
          "PLACEHOLDER": "Bitte geben Sie einen Namen für den Posteingang ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "PLACEHOLDER": "Bitte geben Sie die Telefonnummer ein, von der die Nachricht gesendet wird.",
          "ERROR": "Bitte geben Sie eine gültige Telefonnummer an, die mit einem `+` Zeichen beginnt und keine Leerzeichen enthält."
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Sie müssen die Callback-URL in Twilio mit der hier genannten URL konfigurieren."
        },
        "SUBMIT_BUTTON": "Erstellen Sie Twilio Channel",
        "API": {
          "ERROR_MESSAGE": "Wir konnten die Twilio-Anmeldeinformationen nicht authentifizieren. Bitte versuchen Sie es erneut"
        }
      },
      "SMS": {
        "TITLE": "SMS Kanal",
        "DESC": "Beginnen Sie, Ihre Kunden per SMS zu unterstützen.",
        "PROVIDERS": {
          "LABEL": "API-Provider",
          "TWILIO": "Twilio",
          "BANDWIDTH": "Bandbreite",
          "SMS_BRANA": "SMS Brana",
          "DIDWW": "DIDWW"
        },
        "API": {
          "ERROR_MESSAGE": "Wir konnten den SMS-Kanal nicht speichern"
        },
        "BANDWIDTH": {
          "ACCOUNT_ID": {
            "LABEL": "Account ID",
            "PLACEHOLDER": "Bitte geben Sie Ihre Bandbreitenkonto-ID ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "API_KEY": {
            "LABEL": "API-Schlüssel",
            "PLACEHOLDER": "Bitte geben Sie Ihren Bandbreiten-API-Schlüssel ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "API_SECRET": {
            "LABEL": "API-Secret",
            "PLACEHOLDER": "Bitte geben Sie Ihr Bandbreiten-API-Geheimnis ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "APPLICATION_ID": {
            "LABEL": "Anwendungs-ID",
            "PLACEHOLDER": "Bitte geben Sie Ihre Bandbreitenanwendungs-ID ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "INBOX_NAME": {
            "LABEL": "Posteingang-Name",
            "PLACEHOLDER": "Bitte geben Sie einen Namen für den Posteingang ein",
            "ERROR": "Dieses Feld wird benötigt"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Bitte geben Sie die Telefonnummer ein, von der die Nachricht gesendet wird.",
            "ERROR": "Bitte geben Sie eine gültige Telefonnummer an, die mit einem `+` Zeichen beginnt und keine Leerzeichen enthält."
          },
          "SUBMIT_BUTTON": "Bitte geben Sie Ihre Bandbreitenanwendungs-ID ein",
          "API": {
            "ERROR_MESSAGE": "Wir konnten die Bandbreiten-Anmeldeinformationen nicht authentifizieren. Bitte versuchen Sie es erneut"
          },
          "API_CALLBACK": {
            "TITLE": "Callback URL",
            "SUBTITLE": "Sie müssen die Nachrichten-Callback-URL in Bandbreite mit der hier erwähnten URL konfigurieren."
          }
        },
        "SMS_BRANA": {
          "INBOX_NAME": {
            "LABEL": "Posteingangsname",
            "PLACEHOLDER": "Bitte geben Sie einen Posteingangsnamen ein",
            "ERROR": "Dieses Feld ist erforderlich"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Bitte geben Sie die Telefonnummer ein, von der Nachrichten gesendet werden.",
            "ERROR": "Bitte geben Sie eine gültige Telefonnummer mit führendem + an."
          },
          "SUBMIT_BUTTON": "SMS-Brana-Kanal erstellen",
          "API": {
            "ERROR_MESSAGE": "Der SMS-Brana-Kanal konnte nicht erstellt werden"
          }
        },
        "DIDWW": {
          "INBOX_NAME": {
            "LABEL": "Posteingangsname",
            "PLACEHOLDER": "Bitte geben Sie einen Posteingangsnamen ein",
            "ERROR": "Dieses Feld ist erforderlich"
          },
          "PHONE_NUMBER": {
            "LABEL": "Telefonnummer",
            "PLACEHOLDER": "Bitte geben Sie die Telefonnummer ein, von der Nachrichten gesendet werden.",
            "ERROR": "Bitte geben Sie eine gültige Telefonnummer mit führendem + an."
          },
          "SUBMIT_BUTTON": "DIDWW-Kanal erstellen",
          "API": {
            "ERROR_MESSAGE": "Der DIDWW-Kanal konnte nicht erstellt werden"
          }
        }
      },
      "WHATSAPP": {
        "PROVIDERS": {
          "LABEL": "API-Provider",
          "WHATSAPP_CLOUD": "WhatsApp Cloud"
        },
        "API_CALLBACK": {
          "SUBTITLE": "Sie müssen die Webhook-URL und das Verifizierungstoken im Facebook-Entwicklerportal mit den unten gezeigten Werten konfigurieren.",
          "WEBHOOK_URL": "Webhook-URL",
          "WEBHOOK_VERIFICATION_TOKEN": "Webhook-Verifizierungstoken"
        },
        "EMBEDDED_SIGNUP": {
          "TITLE": "Schnelleinrichtung mit Meta",
          "DESC": "Sie werden zu Meta weitergeleitet, um sich bei Ihrem WhatsApp-Business-Konto anzumelden. Admin-Zugriff erleichtert eine reibungslose Einrichtung.",
          "BENEFITS": {
            "EASY_SETUP": "Keine manuelle Konfiguration erforderlich",
            "SECURE_AUTH": "Sichere Authentifizierung auf OAuth-Basis",
            "AUTO_CONFIG": "Automatische Konfiguration von Webhook und Telefonnummer"
          },
          "SUBMIT_BUTTON": "Mit WhatsApp Business verbinden",
          "AUTH_PROCESSING": "Authentifizierung mit Meta",
          "WAITING_FOR_BUSINESS_INFO": "Bitte schließen Sie die Unternehmenseinrichtung im Meta-Fenster ab...",
          "PROCESSING": "Ihr WhatsApp-Business-Konto wird eingerichtet",
          "CANCELLED": "Die WhatsApp-Registrierung wurde abgebrochen",
          "WAITING_FOR_AUTH": "Warten auf Authentifizierung...",
          "INVALID_BUSINESS_DATA": "Ungültige Unternehmensdaten von Facebook erhalten. Bitte versuchen Sie es erneut.",
          "SIGNUP_ERROR": "Fehler bei der Registrierung",
          "SDK_LOAD_ERROR": "Das Facebook SDK konnte nicht geladen werden. Bitte versuchen Sie es erneut.",
          "AUTH_NOT_COMPLETED": "Authentifizierung nicht abgeschlossen. Bitte starten Sie den Vorgang erneut.",
          "SUCCESS_FALLBACK": "Das WhatsApp-Business-Konto wurde erfolgreich konfiguriert",
          "RECONNECTED": "WhatsApp-Kanal erfolgreich wieder verbunden"
        },
        "API": {
          "ERROR_MESSAGE": "Wir konnten den WhatsApp-Kanal nicht speichern"
        }
      },
      "API_CHANNEL": {
        "TITLE": "API-Kanal",
        "DESC": "Integrieren Sie einen API-Kanal und starten Sie mit der Unterstützung Ihrer Kunden.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Name",
          "PLACEHOLDER": "Bitte geben Sie einen Kanalnamen ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "WEBHOOK_URL": {
          "LABEL": "Webhook-URL",
          "SUBTITLE": "Konfigurieren Sie die URL, unter der Sie Rückrufe bei Ereignissen empfangen möchten.",
          "PLACEHOLDER": "Webhook-URL"
        },
        "SUBMIT_BUTTON": "API-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Der API-Kanal konnte nicht gespeichert werden"
        }
      },
      "EMAIL_CHANNEL": {
        "TITLE": "E-Mail-Kanal",
        "DESC": "Integrieren Sie Ihren E-Mail-Posteingang.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Name",
          "PLACEHOLDER": "Bitte geben Sie einen Kanalnamen ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "EMAIL": {
          "LABEL": "E-Mail",
          "SUBTITLE": "E-Mail Adresse, an die Ihre Kunden Ihnen Support-Tickets senden",
          "PLACEHOLDER": "E-Mail"
        },
        "SUBMIT_BUTTON": "E-Mail-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Wir konnten den E-Mail-Kanal nicht speichern"
        },
        "FINISH_MESSAGE": "Starten Sie die Weiterleitung Ihrer E-Mails an die folgende E-Mail-Adresse."
      },
      "LINE_CHANNEL": {
        "TITLE": "LINE-Kanal",
        "DESC": "Integrieren Sie den LINE-Kanal und unterstützen Sie Ihre Kunden.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Name",
          "PLACEHOLDER": "Bitte geben Sie einen Kanalnamen ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "LINE_CHANNEL_ID": {
          "LABEL": "LINE-Kanal-ID",
          "PLACEHOLDER": "LINE-Kanal-ID"
        },
        "LINE_CHANNEL_SECRET": {
          "LABEL": "LINE-Kanal-Geheimnis",
          "PLACEHOLDER": "LINE-Kanal-Secret"
        },
        "LINE_CHANNEL_TOKEN": {
          "LABEL": "LINE-Kanal-Token",
          "PLACEHOLDER": "LINE-Kanal-Token"
        },
        "SUBMIT_BUTTON": "LINE-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Wir konnten den LINE-Kanal nicht speichern"
        },
        "API_CALLBACK": {
          "TITLE": "Callback URL",
          "SUBTITLE": "Sie müssen die Webhook-URL in der LINE-Anwendung mit der hier genannten URL konfigurieren."
        }
      },
      "TELEGRAM_CHANNEL": {
        "TITLE": "Telegram-Kanal",
        "DESC": "Integrieren Sie den Telegram-Kanal und unterstützen Sie Ihre Kunden.",
        "BOT_TOKEN": {
          "LABEL": "Bot-Token",
          "SUBTITLE": "Konfigurieren Sie den Bot-Token, welchen Sie von Telegram BotFather erhalten haben.",
          "PLACEHOLDER": "Bot-Token"
        },
        "SUBMIT_BUTTON": "Telegram-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Wir konnten den Telegram-Kanal nicht speichern"
        }
      },
      "AUTH": {
        "TITLE": "Wählen Sie einen Kanal",
        "DESC": "Der Chat unterstützt Live-Chat-Widgets, Facebook Messenger, WhatsApp, E-Mails usw. als Kanäle. Wenn Sie einen benutzerdefinierten Kanal erstellen möchten, können Sie ihn mithilfe des API-Kanals erstellen. Wählen Sie zunächst einen der folgenden Kanäle aus."
      },
      "AGENTS": {
        "TITLE": "Agenten",
        "DESC": "Hier können Sie Agenten hinzufügen, um Ihren neu erstellten Posteingang zu verwalten. Nur diese ausgewählten Agenten haben Zugriff auf Ihren Posteingang. Agenten, die nicht Teil dieses Posteingangs sind, können bei der Anmeldung keine Nachrichten in diesem Posteingang sehen oder darauf antworten. <br> <b> PS: </b> Wenn Sie als Administrator Zugriff auf alle Posteingänge benötigen, sollten Sie sich als Agent zu allen von Ihnen erstellten Posteingängen hinzufügen.",
        "VALIDATION_ERROR": "Fügen Sie mindestens einen Agenten zu Ihrem neuen Posteingang hinzu",
        "PICK_AGENTS": "Agenten für den Posteingang auswählen"
      },
      "DETAILS": {
        "TITLE": "Posteingangsdetails",
        "DESC": "Wählen Sie aus der Dropdown-Liste die Facebook-Seite aus, die Sie mit dem Chat verbinden möchten. Sie können Ihrem Posteingang auch einen benutzerdefinierten Namen geben, um ihn besser identifizieren zu können."
      },
      "FINISH": {
        "TITLE": "Geschafft!",
        "DESC": "Sie haben die Integration Ihrer Facebook-Seite in den Chat erfolgreich abgeschlossen. Wenn ein Kunde das nächste Mal eine Nachricht an Ihre Seite sendet, wird die Konversation automatisch in Ihrem Posteingang angezeigt. <br> Wir stellen Ihnen außerdem ein Widget-Skript zur Verfügung, das Sie ganz einfach zu Ihrer Website hinzufügen können. Sobald dies auf Ihrer Website live ist, können Kunden Ihnen ohne Hilfe eines externen Tools direkt von Ihrer Website aus eine Nachricht senden, und die Konversation wird direkt hier im Chat angezeigt. <br> Cool, oder? Nun, wir versuchen es auf jeden Fall :)"
      },
      "EMAIL_PROVIDER": {
        "TITLE": "Wählen Sie Ihren E-Mail-Anbieter",
        "DESCRIPTION": "Wählen Sie einen E-Mail-Anbieter aus der Liste unten. Wenn Ihr E-Mail-Provider nicht in der Liste steht, können Sie die 'Anderer Anbieter'-Option auswählen und die Zugangsdaten für IMAP und SMTP angeben."
      },
      "MICROSOFT": {
        "TITLE": "Microsoft Email",
        "DESCRIPTION": "Klicken Sie auf die Schaltfläche Einloggen mit Microsoft, um loszulegen. Sie werden zur E-Mail-Anmeldeseite weitergeleitet. Sobald Sie die angeforderten Berechtigungen angenommen haben, werden Sie zum Erstellungsschritt für den Posteingang weitergeleitet.",
        "EMAIL_PLACEHOLDER": "E-Mail-Adresse eingeben",
        "SIGN_IN": "Mit Microsoft anmelden",
        "ERROR_MESSAGE": "Beim Verbinden mit Microsoft ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
      },
      "GOOGLE": {
        "TITLE": "Google E-Mail",
        "DESCRIPTION": "Klicken Sie auf die Schaltfläche Einloggen mit Google, um loszulegen. Sie werden zur E-Mail-Anmeldeseite weitergeleitet. Sobald Sie die angeforderten Berechtigungen angenommen haben, werden Sie zum Erstellungsschritt für den Posteingang weitergeleitet.",
        "SIGN_IN": "Mit Google anmelden",
        "EMAIL_PLACEHOLDER": "E-Mail-Adresse eingeben",
        "ERROR_MESSAGE": "There was an error connecting to Google, please try again"
      },
      "INTERNAL_NAME": {
        "LABEL": "Interner Name",
        "PLACEHOLDER": "Bezeichnen Sie den Posteingang wie er in diesem Dashboard angezeigt wird",
        "ERROR": "Bitte geben Sie einen eindeutigen internen Namen ein"
      },
      "INSTAGRAM": {
        "CONTINUE_WITH_INSTAGRAM": "Mit Instagram fortfahren",
        "CONNECT_YOUR_INSTAGRAM_PROFILE": "Instagram-Profil verbinden",
        "HELP": "Um Ihr Instagram-Profil als Kanal hinzuzufügen, müssen Sie Ihr Instagram-Profil authentifizieren, indem Sie auf \"Mit Instagram fortfahren\" klicken ",
        "ERROR_MESSAGE": "Beim Verbinden mit Instagram ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
        "ERROR_AUTH": "Beim Verbinden mit Instagram ist ein Fehler aufgetreten, bitte versuchen Sie es erneut",
        "NEW_INBOX_SUGGESTION": "Dieses Instagram-Konto war zuvor mit einem anderen Posteingang verknüpft und wurde hierher migriert. Alle neuen Nachrichten erscheinen hier. Der alte Posteingang kann keine Nachrichten für dieses Konto mehr senden oder empfangen.",
        "DUPLICATE_INBOX_BANNER": "Dieses Instagram-Konto wurde in den neuen Instagram-Kanal-Posteingang migriert. Sie können aus diesem Posteingang keine Instagram-Nachrichten mehr senden/empfangen."
      },
      "SALESFORCE_CHANNEL": {
        "TITLE": "Salesforce-Kanal",
        "DESC": "In den Salesforce-Kanal integrieren und Kunden betreuen.",
        "CHANNEL_NAME": {
          "LABEL": "Kanalname",
          "PLACEHOLDER": "Bitte geben Sie einen Kanalnamen ein",
          "ERROR": "Dieses Feld ist erforderlich"
        },
        "API_BASE_URL": {
          "LABEL": "Salesforce-API-URL",
          "SUBTITLE": "Konfigurieren Sie die Basis-URL Ihrer Salesforce-Instanz.",
          "PLACEHOLDER": "URL der Salesforce-API",
          "ERROR": "Dieses Feld ist erforderlich"
        },
        "KEY_ID": {
          "LABEL": "Key-ID",
          "SUBTITLE": "Key-ID Ihres Salesforce-Kanals.",
          "PLACEHOLDER": "KEY ID",
          "ERROR": "Dieses Feld ist erforderlich"
        },
        "SECRET": {
          "LABEL": "Secret",
          "SUBTITLE": "Secret Ihres Salesforce-Kanals.",
          "PLACEHOLDER": "*****",
          "ERROR": "Dieses Feld ist erforderlich"
        },
        "SUBMIT_BUTTON": "Salesforce-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Der Salesforce-Kanal konnte nicht gespeichert werden"
        },
        "API_CALLBACK": {
          "TITLE": "Webhook-URL",
          "SUBTITLE": "Konfigurieren Sie die Webhook-URL in Salesforce mit der hier angegebenen URL."
        },
        "BEARER_TOKEN": {
          "TITLE": "Bearer-Token",
          "SUBTITLE": "Verwenden Sie diesen Bearer-Token zur Authentifizierung beim Konfigurieren des Webhooks in Salesforce."
        },
        "OVERRIDE_EMAIL_SENDER": {
          "TITLE": "E-Mail-Absender überschreiben",
          "SUBTITLE": "Wenn gesetzt, wird diese E-Mail-Adresse als Absender für alle ausgehenden E-Mails verwendet, statt der E-Mail-Adresse der Unterhaltung.",
          "PLACEHOLDER": "z. B. support{'@'}example.com"
        }
      },
      "ALLEGRO_CHANNEL": {
        "TITLE": "Allegro-Kanal",
        "DESC": "Verbinden Sie ein Allegro-Verkäuferkonto und beantworten Sie dessen Nachrichten im Kontaktcenter.",
        "CHANNEL_NAME": {
          "LABEL": "Posteingang-Name",
          "SUBTITLE": "Der Name, den Agenten für diesen Posteingang sehen.",
          "PLACEHOLDER": "Geben Sie einen Posteingangsnamen ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "SUBMIT_BUTTON": "Mit Allegro anmelden",
        "API": {
          "ERROR_MESSAGE": "Bei der Verbindung mit Allegro ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
        },
        "SELLER_LOGIN": {
          "TITLE": "Allegro-Anmeldung",
          "SUBTITLE": "Das Verkäuferkonto, dessen Nachrichten dieser Posteingang liest und beantwortet."
        }
      },
      "KAUFLAND_CHANNEL": {
        "TITLE": "Kaufland-Kanal",
        "DESC": "Beantworten Sie die Ticket-Nachrichten, die Käufer Ihnen auf dem Kaufland-Marktplatz senden.",
        "CHANNEL_NAME": {
          "LABEL": "Kanal Name",
          "PLACEHOLDER": "Bitte geben Sie einen Kanalnamen ein",
          "ERROR": "Dieses Feld wird benötigt"
        },
        "CLIENT_KEY": {
          "LABEL": "Client Key",
          "SUBTITLE": "Der 32 Zeichen lange Client Key von der API-Einstellungsseite Ihres Kaufland-Verkäuferkontos.",
          "PLACEHOLDER": "Schlüssel mit 32 Zeichen",
          "ERROR": "Geben Sie den 32 Zeichen langen Client Key ein"
        },
        "SECRET_KEY": {
          "LABEL": "Secret Key",
          "SUBTITLE": "Der 64 Zeichen lange Secret Key, der zum Client Key gehört. Kaufland zeigt ihn nur einmal an und sendet ihn nie an diese Seite zurück.",
          "PLACEHOLDER": "Schlüssel mit 64 Zeichen",
          "ERROR": "Geben Sie den 64 Zeichen langen Secret Key ein"
        },
        "SUBMIT_BUTTON": "Kaufland-Kanal erstellen",
        "API": {
          "ERROR_MESSAGE": "Der Kaufland-Kanal konnte nicht gespeichert werden"
        },
        "DISCONNECTED": {
          "TITLE": "Nicht verbunden",
          "MESSAGE": "Kaufland hat diese API-Schlüssel abgelehnt. Geben Sie den Client Key und den Secret Key erneut ein, um diesen Posteingang wieder zu verbinden."
        }
      },
      "PHONE_CHANNEL": {
        "TITLE": "Telefonanrufe",
        "DESC": "Legen Sie fest, welche Telefonanrufe in diesem Posteingang angezeigt werden.",
        "NAME": {
          "LABEL": "Posteingangsname",
          "SUBTITLE": "Wählen Sie einen leicht erkennbaren Namen."
        },
        "PHONE_NUMBER": {
          "LABEL": "Telefonnummer",
          "SUBTITLE": "Geben Sie Telefonnummern ein, die zu diesem Posteingang gehören. Sie können später weitere Nummern hinzufügen.",
          "PLACEHOLDER": "+421123908635"
        },
        "SUBMIT_BUTTON": "Posteingang für Telefonanrufe erstellen",
        "API": {
          "ERROR_MESSAGE": "Der Posteingang konnte nicht erstellt werden"
        }
      }
    },
    "DETAILS": {
      "LOADING_FB": "Authentifizierung mit Facebook ...",
      "ERROR_FB_LOADING": "Error loading Facebook SDK. Please disable any ad-blockers and try again from a different browser.",
      "ERROR_FB_AUTH": "Es ist ein Fehler aufgetreten. Bitte Seite aktualisieren ...",
      "ERROR_FB_UNAUTHORIZED": "Sie sind nicht berechtigt, diese Aktion auszuführen. ",
      "ERROR_FB_UNAUTHORIZED_HELP": "Bitte stellen Sie sicher, dass Sie vollen Zugriff auf die Facebook-Seite haben. Weitere Informationen zu Facebook-Rollen finden Sie <a href=\" https://www.facebook.com/help/187316341316631\">here</a>.",
      "ERROR_CHANNEL_CREATION": "Wir konnten den Posteingang nicht erstellen. Bitte versuchen Sie es erneut.",
      "CREATING_CHANNEL": "Erstellen Sie Ihren Posteingang ...",
      "TITLE": "Posteingangsdetails konfigurieren",
      "DESC": ""
    },
    "AGENTS": {
      "BUTTON_TEXT": "Agenten hinzufügen",
      "ADD_AGENTS": "Adding Agents to your Inbox...Hinzufügen von Agenten zu Ihrem Posteingang ..."
    },
    "FINISH": {
      "TITLE": "Ihr Posteingang ist fertig!",
      "MESSAGE": "Sie können jetzt über Ihren neuen Kanal mit Ihren Kunden in Kontakt treten. Fröhliches Unterstützen",
      "BUTTON_TEXT": "Bring mich dahin",
      "MORE_SETTINGS": "Weitere Einstellungen",
      "WEBSITE_SUCCESS": "Sie haben die Erstellung eines Website-Kanals erfolgreich abgeschlossen. Kopieren Sie den unten gezeigten Code und fügen Sie ihn in Ihre Website ein. Wenn ein Kunde das nächste Mal den Live-Chat verwendet, wird die Konversation automatisch in Ihrem Posteingang angezeigt."
    },
    "REAUTH": "Neu autorisieren",
    "VIEW": "Aussicht",
    "EDIT": {
      "API": {
        "SUCCESS_MESSAGE": "Posteingangseinstellungen erfolgreich aktualisiert",
        "AUTO_ASSIGNMENT_SUCCESS_MESSAGE": "Automatische Zuordnung erfolgreich aktualisiert",
        "ERROR_MESSAGE": "Die Posteingangseinstellungen konnten nicht aktualisiert werden. Bitte versuchen Sie es später erneut."
      },
      "EMAIL_COLLECT_BOX": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "ENABLE_CSAT": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "SENDER_NAME_SECTION": {
        "TITLE": "Name des Absenders",
        "SUB_TEXT": "Wählen Sie den Namen aus, der Ihren Kunden angezeigt wird, wenn sie E-Mails von Ihren Agenten erhalten.",
        "FOR_EG": "Zum Beispiel:",
        "FRIENDLY": {
          "TITLE": "Freundlich",
          "FROM": "von",
          "SUBTITLE": "Fügen Sie den Namen des Agenten, der die Antwort gesendet hat, in den Absendernamen ein, um es freundlicher zu gestalten."
        },
        "PROFESSIONAL": {
          "TITLE": "Professionell",
          "SUBTITLE": "Verwenden Sie nur den konfigurierten Firmennamen als Absendernamen in der E-Mail-Kopfzeile."
        },
        "BUSINESS_NAME": {
          "BUTTON_TEXT": "+ Konfigurieren Sie Ihren Firmennamen",
          "PLACEHOLDER": "Geben Sie Ihren Firmennamen ein",
          "SAVE_BUTTON_TEXT": "Speichern"
        }
      },
      "ALLOW_MESSAGES_AFTER_RESOLVED": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "ENABLE_CONTINUITY_VIA_EMAIL": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "RESPOND_FROM_EMAIL": {
        "NONE": "Keine"
      },
      "LOCK_TO_SINGLE_CONVERSATION": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "ENABLE_HMAC": {
        "LABEL": "Aktivieren"
      },
      "FORCE_NEW_CONVERSATION_PER_LOAD": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "NEW_CONVERSATION_FORGETS_CONTACT": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "ENABLE_CSAT_ON_EACH_MESSAGE": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "SHOW_WELCOME_SCREEN": {
        "ENABLED": "Aktiviert",
        "DISABLED": "Deaktiviert"
      },
      "ENABLE_EMAIL_FETCHING": {
        "LABEL": "Synchronisierung eingehender E-Mails aktivieren"
      },
      "ENABLE_CUSTOM_EMAIL": {
        "LABEL": "Eigene E-Mail-Domäne aktivieren (kostenpflichtiger Service)."
      },
      "ENABLE_FACEBOOK_COMMENTS": {
        "LABEL": "Verarbeitung von Facebook-Kommentaren aktivieren"
      },
      "SIGNATURE": {
        "TITLE": "HTML-Signatur",
        "SUB_TEXT": "Diese Signatur wird am Ende jeder aus diesem Posteingang gesendeten Nachricht hinzugefügt.",
        "HTML_CONTENT": "HTML-Code",
        "HTML_CONTENT_HELP": "{'{{'}name{'}}'} wird durch den Namen des Agenten ersetzt.\n{'{{'}email{'}}'} wird durch die E-Mail-Adresse des Agenten ersetzt, der die E-Mail gesendet hat.\n{'{{'}position{'}}'} wird durch die Position des Agenten ersetzt.\n{'{{'}custom_line{'}}'} wird durch die benutzerdefinierte Zeile des Agenten ersetzt.\n{'{{'}email_signature_picture{'}}'} wird durch die URL des E-Mail-Signaturbilds des Agenten ersetzt (kein Bild-Tag) — verwenden Sie sie als Bildquelle (das src-Attribut eines img-Tags).",
        "PREVIEW": "Vorschau"
      },
      "COUNTRY_SIGNATURES": {
        "TITLE": "Signaturen nach Land",
        "SUB_TEXT": "Eine Antwort erhält die Signatur für das Land des Käufers.",
        "HELP": "Eine Antwort wird passend zum Land der Konversation signiert: dem Kaufland-Shop, dem Marktplatz der Allegro-Bestellung oder andernfalls der Sprache, in der der Käufer schreibt. Ist das Land unbekannt oder hat hier keine Signatur, wird die HTML-Signatur oben verwendet. Marktplätze verbieten Links zu Ihrer Website und Kontaktdaten, beschränken Sie sich daher auf eine Grußformel und {'{{'}name{'}}'}.",
        "EMPTY": "Sie haben noch keine Länder-Signaturen, daher verwenden Antworten die HTML-Signatur oben.",
        "COUNTRY": "Land auswählen",
        "ADD": "Länder-Signatur hinzufügen",
        "REMOVE": "Entfernen"
      },
      "PHONE_DIALING_PREFIX": {
        "LABEL": "Präfix für Telefonnummernwahl",
        "PLACEHOLDER": "Präfix für korrekte Anrufweiterleitung eingeben (z. B. *99)",
        "HELP_TEXT": "Dieses Präfix wird beim Wählen aus diesem Posteingang automatisch den Kontakttelefonnummern vorangestellt."
      },
      "RESOLVE_LATER_TEXT": {
        "LABEL": "Text der Schaltfläche „Später klären“",
        "PLACEHOLDER": "z. B. Wir klären dieses Thema per E-Mail. Ich möchte jetzt nach etwas anderem fragen.",
        "HELP_TEXT": "Beschriftung der Widget-Schaltfläche, mit der Besucher das aktuelle Thema verlassen und nach etwas anderem fragen können. Wenn das Feld leer bleibt, wird der Standardtext in der Sprache des Besuchers verwendet."
      },
      "AUTO_SNOOZE_MINUTES": {
        "LABEL": "Verpasste Anrufe automatisch für X Minuten zurückstellen",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Verpasste Anrufe automatisch für die angegebene Anzahl Minuten zurückstellen. Leer oder 0 lassen, um die Funktion zu deaktivieren."
      },
      "AUTO_RESOLVE_AFTER_FAILED_ATTEMPTS": {
        "LABEL": "Verpassten Anruf nach X erfolglosen Rückrufen lösen",
        "PLACEHOLDER": "0",
        "HELP_TEXT": "Wenn ein verpasster Anruf X-mal zurückgerufen wurde, ohne dass der Kunde abgehoben hat, wird er automatisch gelöst und es wird eine private Notiz hinzugefügt. Leer oder 0 lassen, um die Funktion zu deaktivieren."
      },
      "QUESTION_SUGGESTIONS": {
        "TITLE": "Fragen-Vorschläge",
        "SUB_TEXT": "Konfigurieren Sie vordefinierte Fragen, die Kunden für die Interaktion mit Agenten verwenden können.",
        "QUESTIONS_LABEL": "Fragen",
        "ADD_QUESTION": "Frage hinzufügen",
        "QUESTION": "Frage",
        "REMOVE": "Entfernen",
        "QUESTION_TEXT": "Im Bubble angezeigter Text.",
        "QUESTION_TEXT_PLACEHOLDER": "Erforderlich",
        "QUESTION_PAYLOAD": "Beim Klicken gesendeter Text.",
        "QUESTION_PAYLOAD_PLACEHOLDER": "Optional",
        "SAVE": "Speichern",
        "NO_BOT_MESSAGE": "Um zusätzliche KI-Vorschläge zu generieren, verbinden Sie bitte einen Bot.",
        "BOT_CONNECTED_MESSAGE": "KI-Fragen-Vorschläge vom Bot können aktiviert werden in dessen",
        "BOT_SETTINGS_LINK": "Einstellungen"
      },
      "ALTERNATIVE_EMAILS": {
        "TITLE": "Alternative E-Mail-Adressen",
        "SUB_TEXT": "Zusätzliche Adressen, die dieser Posteingang beim Empfang weitergeleiteter E-Mails als seine eigenen behandeln soll.",
        "PLACEHOLDER": "alias{'@'}example.com",
        "ADD": "Hinzufügen",
        "REMOVE": "Entfernen",
        "EMPTY": "Keine alternativen E-Mail-Adressen konfiguriert.",
        "HELP_TEXT": "Wenn eine E-Mail an eine dieser Adressen als Empfänger eingeht, werden Antworten mit derselben Adresse als Absender gesendet. Stellen Sie sicher, dass Ihr ausgehender SMTP-Server das Senden von diesen Adressen erlaubt.",
        "SIGNATURE_LABEL": "Signatur",
        "PRIMARY_SIGNATURE": "Primär (Standard)"
      },
      "ADDITIONAL_SIGNATURES": {
        "TITLE": "Zusätzliche Signaturen",
        "SUB_TEXT": "Definieren Sie hier zusätzliche Signaturen und weisen Sie sie dann den alternativen E-Mail-Adressen unten zu.",
        "OPTION": "Signatur {number}",
        "ADD": "Signatur hinzufügen",
        "REMOVE": "Entfernen",
        "HELP_TEXT": "Wenn eine Antwort von einer alternativen E-Mail-Adresse gesendet wird, wird die ihr zugewiesene Signatur anstelle der Postfach-Signatur verwendet. Alternative E-Mail-Adressen, die auf „Primär (Standard)“ belassen werden, verwenden die Postfach-Signatur."
      }
    },
    "DELETE": {
      "BUTTON_TEXT": "Löschen",
      "AVATAR_DELETE_BUTTON_TEXT": "Avatar löschen",
      "CONFIRM": {
        "TITLE": "Löschung bestätigen",
        "MESSAGE": "Bist du sicher, das du das löschen möchtest ",
        "PLACE_HOLDER": "Bitte geben Sie {inboxName} zur Bestätigung ein",
        "YES": "Ja, löschen",
        "NO": "Nein, behalten "
      },
      "API": {
        "SUCCESS_MESSAGE": "Posteingang erfolgreich gelöscht",
        "ERROR_MESSAGE": "Posteingang konnte nicht gelöscht werden. Bitte versuchen Sie es später noch einmal.",
        "AVATAR_SUCCESS_MESSAGE": "Avatar von Posteingang erfolgreich gelöscht",
        "AVATAR_ERROR_MESSAGE": "Der Avatar vom Posteingang konnte nicht gelöscht werden. Bitte versuchen Sie es später erneut.",
        "MARKED_FOR_DELETION_MESSAGE": "Posteingang zum Löschen markiert",
        "RESTORE_SUCCESS_MESSAGE": "Posteingang erfolgreich wiederhergestellt",
        "RESTORE_ERROR_MESSAGE": "Posteingang konnte nicht wiederhergestellt werden. Bitte versuchen Sie es später erneut."
      },
      "DELETE_REQUESTED_TOOLTIP": "Dieser Posteingang ist zum Löschen markiert",
      "RESTORE_BUTTON_TEXT": "Wiederherstellen"
    },
    "TABS": {
      "SETTINGS": "Einstellungen",
      "COLLABORATORS": "Mitarbeitende",
      "CONFIGURATION": "Konfiguration",
      "CAMPAIGN": "Kampagnen",
      "PRE_CHAT_FORM": "Pre-Chat-Formular",
      "BUSINESS_HOURS": "Öffnungszeiten",
      "WIDGET_BUILDER": "Widget-Generator",
      "BOT_CONFIGURATION": "Bot-Konfiguration",
      "AUTOMATIC_PRIORITY": "Automatische Priorität",
      "AUTOMATIC_LABELING": "Automatische Kennzeichnung",
      "SLA": "SLA"
    },
    "SETTINGS": "Einstellungen",
    "FEATURES": {
      "LABEL": "Funktionen",
      "DISPLAY_FILE_PICKER": "Dateiauswahl im Widget anzeigen",
      "DISPLAY_EMOJI_PICKER": "Emoji-Auswahl im Widget anzeigen",
      "ALLOW_END_CONVERSATION": "Benutzern erlauben, die Konversation vom Widget zu beenden",
      "SHOW_START_NEW_CONVERSATION_BUTTON": "Schaltfläche 'Neue Konversation starten' in der Widget-Kopfzeile anzeigen",
      "HIDE_INPUT_UNDER_START_NEW_CONVERSATION_BUTTON": "Eingabefeld ausblenden, wenn die Schaltfläche „Neue Konversation starten“ angezeigt wird",
      "SHOW_HANDOFF_BUTTON": "Schaltfläche 'An einen Mitarbeiter weiterleiten' in der Widget-Kopfzeile anzeigen",
      "USE_INBOX_AVATAR_FOR_BOT": "Posteingangsname und Avatar für den Bot verwenden",
      "ALLOW_OFFLINE_REPLY": "Agenten erlauben, Nachrichten zu senden, wenn der Kontakt offline ist und E-Mail-Continuity nicht verfügbar ist",
      "AUTO_CLOSE_OLD": "Alle vergangenen Anrufe von derselben Nummer als gelöst markieren, sobald einer gelöst wurde",
      "AUTO_ASSIGN_MISSED_ON_OUTGOING": "Verpasste Anrufe automatisch zuweisen, wenn ein ausgehender Anruf getätigt wird"
    },
    "SETTINGS_POPUP": {
      "MESSENGER_HEADING": "Messenger-Skript",
      "MESSENGER_SUB_HEAD": "Platzieren Sie diese Schaltfläche in Ihrem Body-Tag",
      "INBOX_AGENTS": "Agenten",
      "INBOX_AGENTS_SUB_TEXT": "Hinzufügen oder Entfernen von Agenten zu diesem Posteingang",
      "AGENT_ASSIGNMENT": "Konversationssauftrag",
      "AGENT_ASSIGNMENT_SUB_TEXT": "Konversationszuweisungseinstellungen aktualisieren",
      "UPDATE": "Aktualisieren",
      "ENABLE_EMAIL_COLLECT_BOX": "E-Mail-Sammelbox aktivieren",
      "ENABLE_EMAIL_COLLECT_BOX_SUB_TEXT": "E-Mail-Sammelbox für neue Konversation aktivieren oder deaktivieren",
      "AUTO_ASSIGNMENT": "Aktivieren Sie die automatische Zuweisung",
      "ENABLE_CSAT": "CSAT aktivieren",
      "SENDER_NAME_SECTION": "Aktivieren Sie den Agentennamen in der E-Mail",
      "ENABLE_CSAT_SUB_TEXT": "CSAT(Kundenzufriedenheit) Umfrage aktivieren/deaktivieren nach Abschluss eines Gesprächs",
      "SENDER_NAME_SECTION_TEXT": "Aktivieren/Deaktivieren Sie die Anzeige des Agentennamens in der E-Mail. Wenn deaktiviert, wird der Firmenname angezeigt",
      "ENABLE_CONTINUITY_VIA_EMAIL": "Konversationskontinuität per E-Mail aktivieren",
      "ENABLE_CONTINUITY_VIA_EMAIL_SUB_TEXT": "Konversationen werden per E-Mail fortgesetzt, wenn die Kontakt-E-Mail-Adresse verfügbar ist.",
      "RESPOND_FROM_EMAIL": "Antworten per E-Mail von",
      "RESPOND_FROM_EMAIL_SUB_TEXT_WEBWIDGET": "E-Mails an den Kunden — sowohl Antworten als auch Unterhaltungs-Transkripte — werden über die SMTP-Einstellungen des ausgewählten E-Mail-Posteingangs von der ausgewählten Adresse (der eigenen Adresse des Posteingangs oder einem seiner Aliasse) gesendet, und die Antworten des Kunden gehen über dessen IMAP-Adresse ein.",
      "RESPOND_FROM_EMAIL_SUB_TEXT_OTHER": "Unterhaltungs-Transkripte werden über die SMTP-Einstellungen des ausgewählten E-Mail-Posteingangs von der ausgewählten Adresse (der eigenen Adresse des Posteingangs oder einem seiner Aliasse) gesendet, wobei Antworten über dessen IMAP-Adresse eingehen.",
      "LOCK_TO_SINGLE_CONVERSATION": "Mehrere Konversationen zulassen",
      "LOCK_TO_SINGLE_CONVERSATION_SUB_TEXT": "Mehrere gleichzeitige Unterhaltungen für denselben Kontakt in diesem Posteingang aktivieren oder deaktivieren",
      "INBOX_UPDATE_TITLE": "Posteingangseinstellungen",
      "INBOX_UPDATE_SUB_TEXT": "Posteingangseinstellungen aktualisieren",
      "AUTO_ASSIGNMENT_SUB_TEXT": "Aktivieren oder deaktivieren Sie die automatische Zuweisung verfügbarer Agenten für neue Konversationen",
      "HMAC_VERIFICATION": "Benutzeridentitätsüberprüfung",
      "HMAC_DESCRIPTION": "Um die Identität des Benutzers zu validieren, können Sie für jeden Benutzer einen `identifier_hash` übergeben. Sie können einen HMAC sha256-Hash generieren, indem Sie den 'Bezeichner' mit dem hier gezeigten Schlüssel verwenden.",
      "HMAC_LINK_TO_DOCS": "Lesen Sie hier mehr.",
      "HMAC_MANDATORY_VERIFICATION": "Erzwinge Benutzer-Identitätsüberprüfung",
      "HMAC_MANDATORY_DESCRIPTION": "Wenn aktiviert, werden Anfragen, denen der `identifier_hash` fehlt, abgelehnt.",
      "FORCE_NEW_CONVERSATION_PER_LOAD_TITLE": "Bei jedem Laden des Widgets eine neue Konversation erzwingen",
      "FORCE_NEW_CONVERSATION_PER_LOAD_SUBTITLE": "Wenn aktiviert, startet das Öffnen des Widgets in einem neuen Tab oder Fenster eine neue Konversation.",
      "NEW_CONVERSATION_FORGETS_CONTACT_TITLE": "Kontakt vergessen, wenn eine neue Konversation gestartet wird",
      "NEW_CONVERSATION_FORGETS_CONTACT_SUBTITLE": "Wenn deaktiviert, behält eine über das Widget gestartete neue Konversation den vorherigen Kontakt bei.",
      "INBOX_IDENTIFIER": "Identifizierung für Posteingang",
      "INBOX_IDENTIFIER_SUB_TEXT": "Verwenden Sie den hier angezeigten `inbox_identifier`-Token zur Authentifizierung Ihrer API-Clients.",
      "FORWARD_EMAIL_TITLE": "Weiterleitung an E-Mail",
      "FORWARD_EMAIL_SUB_TEXT": "Starten Sie die Weiterleitung Ihrer E-Mails an die folgende E-Mail-Adresse.",
      "ALLOW_MESSAGES_AFTER_RESOLVED": "Nachrichten zulassen, nachdem die Konversation gelöst wurde",
      "ALLOW_MESSAGES_AFTER_RESOLVED_SUB_TEXT": "Den Endbenutzern erlauben, Nachrichten zu versenden, auch wenn die Unterhaltung abgeschlossen ist.",
      "UPDATE_PRE_CHAT_FORM_SETTINGS": "Pre Chat Einstellungen aktualisieren",
      "INBOX_TEAMS": "Teams",
      "INBOX_COOPERATORS": "Mitarbeiter",
      "SELECT_PLACEHOLDER": "Auswählen",
      "AGENTS_OR_TEAMS_INFO": "Sie können entweder Agenten oder Teams zuweisen – nicht beides gleichzeitig.",
      "ENABLE_CSAT_ON_EACH_MESSAGE": "CSAT bei jeder Nachricht aktivieren",
      "ENABLE_CSAT_ON_EACH_MESSAGE_SUB_TEXT": "CSAT-Umfrageoption für jede von Agenten gesendete Nachricht aktivieren/deaktivieren",
      "SHOW_WELCOME_SCREEN": "Willkommensbildschirm anzeigen",
      "SHOW_WELCOME_SCREEN_TOOLTIP": "Beim Öffnen des Widgets den Willkommensbildschirm anzeigen. Bei Deaktivierung wechselt das Widget direkt zur Unterhaltungsansicht.",
      "AUTO_CLOSE_PENDING": "KI-Chats automatisch lösen nach (Stunden)",
      "AUTO_CLOSE_PENDING_SUB_TEXT": "KI-Chats nach X Stunden Inaktivität automatisch lösen.",
      "HMAC_ROTATE": {
        "BUTTON": "Schlüssel rotieren",
        "TITLE": "Schlüssel rotieren?",
        "WARNING": "Der aktuelle Schlüssel wird in dem Moment widerrufen, in dem Sie ihn rotieren.",
        "WARNING_DETAIL": "Es gibt keine Übergangszeit, und er kann nicht wiederhergestellt werden.",
        "IMPACT": "Ihre Server müssen Benutzer mit dem neuen Schlüssel signieren. Wer noch mit dem alten Schlüssel signiert ist, besteht die Verifizierung nicht. Ist eine Identitätsprüfung erforderlich, kann diese Person keine Unterhaltung starten.",
        "CONFIRM": "Schlüssel rotieren",
        "CANCEL": "Abbrechen",
        "SUCCESS": "Schlüssel erfolgreich rotiert",
        "ERROR": "Der Schlüssel konnte nicht rotiert werden, bitte versuchen Sie es erneut"
      },
      "EMAIL_FETCHING_ENABLED_TITLE": "E-Mail-Synchronisierung",
      "EMAIL_FETCHING_ENABLED_DESCRIPTION": "Automatisches Synchronisieren und Herunterladen eingehender E-Mails aus diesem Posteingang aktivieren",
      "CUSTOM_EMAIL_ENABLED_TITLE": "Eigene E-Mail-Domäne",
      "CUSTOM_EMAIL_ENABLED_DESCRIPTION": "Aktivieren, um eine eigene E-Mail-Domäne für ausgehende E-Mails zu verwenden",
      "CUSTOM_EMAIL_ENABLED_LINK_TO_DOCS": "Hier können Sie mehr erfahren.",
      "FACEBOOK_COMMENTS_TITLE": "Facebook-Kommentare",
      "WIDGET_STATUS_LABEL": "Widget-Status",
      "WIDGET_STATUS_ENABLED": "Aktiviert",
      "WIDGET_STATUS_BUSINESS_HOURS": "Während der Geschäftszeiten aktiviert",
      "WIDGET_STATUS_DISABLED": "Deaktiviert",
      "WIDGET_STATUS_HELP_TEXT": "Legen Sie fest, wann das Widget Besuchern Ihrer Website angezeigt wird",
      "EXPLICIT_CSAT_LOCALE": "Sprache für CSAT-Umfrage und E-Mail",
      "EXPLICIT_CSAT_LOCALE_SUB_TEXT": "Wählen Sie die Sprache für alle Kunden-E-Mails einschließlich CSAT-Umfragen, Unterhaltungstranskripte und E-Mail-Benachrichtigungen",
      "EXPLICIT_CSAT_LOCALE_INHERIT": "Vom Konto übernehmen",
      "WHATSAPP_CONNECTION": {
        "TITLE": "WhatsApp-Verbindung",
        "SUBTITLE": "So ist dieser Posteingang mit WhatsApp verbunden.",
        "PROVIDER": "Anbieter",
        "PROVIDER_VALUE": "WhatsApp Cloud API (Meta)",
        "EMBEDDED_SIGNUP": "Verbunden über die eingebettete Registrierung von Meta",
        "STATUS": "Status",
        "CONNECTED": "Verbunden",
        "RECONNECT_HINT": "Klicken Sie im Hinweis oben auf „Neu verbinden“.",
        "PHONE_NUMBER": "Telefonnummer",
        "BUSINESS_ACCOUNT": "WhatsApp-Business-Konto-ID",
        "OPEN_MANAGER": "Im WhatsApp Manager öffnen",
        "PHONE_NUMBER_ID": "Telefonnummer-ID",
        "TEMPLATES": "Nachrichtenvorlagen",
        "TEMPLATES_COUNT": "{approved} von {total} genehmigt",
        "TEMPLATES_SYNCED": "Zuletzt synchronisiert: {date}",
        "TEMPLATES_NOT_SYNCED": "Noch nicht synchronisiert",
        "MANAGE_TEMPLATES": "Vorlagen verwalten"
      }
    },
    "HELP_CENTER": {
      "LABEL": "Hilfezentrum",
      "PLACEHOLDER": "Hilfezentrum auswählen",
      "SELECT_PLACEHOLDER": "Hilfezentrum auswählen",
      "REMOVE": "Hilfezentrum entfernen",
      "SUB_TEXT": "Ein Hilfezentrum am Posteingang anhängen"
    },
    "AUTO_ASSIGNMENT": {
      "MAX_ASSIGNMENT_LIMIT": "Limit für automatische Zuweisung",
      "MAX_ASSIGNMENT_LIMIT_RANGE_ERROR": "Bitte geben Sie einen Wert größer als 0 ein",
      "MAX_ASSIGNMENT_LIMIT_SUB_TEXT": "Beschränken Sie die maximale Anzahl von Konversationen aus diesem Posteingang, die einem Agenten automatisch zugewiesen werden können"
    },
    "FACEBOOK_REAUTHORIZE": {
      "TITLE": "Neu autorisieren",
      "SUBTITLE": "Ihre Facebook-Verbindung ist abgelaufen, bitte verbinden Sie sich neu, um die Dienste fortzuführen",
      "MESSAGE_SUCCESS": "Wiederverbindung erfolgreich",
      "MESSAGE_ERROR": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
    },
    "PRE_CHAT_FORM": {
      "DESCRIPTION": "Pre-Chat-Formulare ermöglichen es Ihnen, Benutzerinformationen zu erfassen, bevor sie mit Ihnen ins Gespräch kommen.",
      "SET_FIELDS": "Formularfelder vor dem Chat",
      "SET_FIELDS_HEADER": {
        "FIELDS": "Felder",
        "LABEL": "Label",
        "PLACE_HOLDER": "Platzhalter",
        "KEY": "Schlüssel",
        "TYPE": "Typ",
        "REQUIRED": "Benötigt"
      },
      "ENABLE": {
        "LABEL": "Vorab Chatformulare aktivieren",
        "OPTIONS": {
          "ENABLED": "Ja",
          "DISABLED": "Nein"
        }
      },
      "PRE_CHAT_MESSAGE": {
        "LABEL": "Pre-Chat-Nachricht",
        "PLACEHOLDER": "Diese Nachricht ist für alle Benutzer dieses Formulars sichtbar"
      },
      "REQUIRE_EMAIL": {
        "LABEL": "Besucher sollten ihren Namen und ihre E-Mail-Adresse angeben, bevor sie den Chat starten"
      }
    },
    "BUSINESS_HOURS": {
      "TITLE": "Legen Sie Ihre Verfügbarkeit fest",
      "SUBTITLE": "Legen Sie die Verfügbarkeit für das Live-Chat-Widget fest",
      "WEEKLY_TITLE": "Wöchentliche Stunden festlegen",
      "TIMEZONE_LABEL": "Zeitzone auswählen",
      "UPDATE": "Einstellungen für Geschäftszeiten aktualisieren",
      "TOGGLE_AVAILABILITY": "Geschäftszeiten für diesen Posteingang aktivieren",
      "UNAVAILABLE_MESSAGE_LABEL": "Nachricht für Besucher außerhalb Geschäftszeiten",
      "TOGGLE_HELP": "Wenn die Geschäftsverfügbarkeit aktiviert ist, werden die verfügbaren Stunden im Live-Chat-Widget angezeigt, auch wenn alle Agenten offline sind. Außerhalb der verfügbaren Stunden können Besucher mit einer Nachricht und einem Chat-Formular gewarnt werden.",
      "DAY": {
        "ENABLE": "Verfügbarkeit für diesen Tag aktivieren",
        "UNAVAILABLE": "Nicht verfügbar",
        "HOURS": "Stunden",
        "VALIDATION_ERROR": "Die Startzeit sollte vor der Schließzeit liegen.",
        "CHOOSE": "Auswählen"
      },
      "ALL_DAY": "Den ganzen Tag",
      "SAVE_TO_ALL": "In alle Posteingänge speichern",
      "SAVE_TO_ALL_TITLE": "Arbeitszeiten kopieren",
      "SAVE_TO_ALL_CONFIRM": "Die Einstellungen dieses Formulars (Verfügbarkeitsschalter, Abwesenheitsnachricht, Zeitzone und Arbeitszeiten) werden in alle anderen Posteingänge außer E-Mail- und Telefon-Posteingänge kopiert. Sind Sie sicher, dass Sie fortfahren möchten?",
      "SAVE_TO_ALL_CANCEL": "Abbrechen",
      "SAVE_TO_ALL_YES": "Ja, in alle kopieren",
      "SAVE_TO_ALL_SUCCESS": "Arbeitszeiten erfolgreich in alle anderen Posteingänge kopiert",
      "SAVE_TO_ALL_ERROR": "Arbeitszeiten konnten nicht in andere Posteingänge kopiert werden"
    },
    "IMAP": {
      "TITLE": "IMAP",
      "SUBTITLE": "Setzen Sie Ihre IMAP-Daten",
      "NOTE_TEXT": "Um SMTP zu aktivieren, konfigurieren Sie bitte IMAP.",
      "UPDATE": "IMAP-Einstellungen aktualisieren",
      "TOGGLE_AVAILABILITY": "IMAP-Konfiguration für diesen Posteingang aktivieren",
      "TOGGLE_HELP": "Wenn IMAP aktiviert ist, kann der Benutzer E-Mails empfangen",
      "EDIT": {
        "SUCCESS_MESSAGE": "IMAP-Einstellungen erfolgreich aktualisiert",
        "ERROR_MESSAGE": "IMAP-Einstellungen können nicht aktualisiert werden"
      },
      "ADDRESS": {
        "LABEL": "Adresse",
        "PLACE_HOLDER": "Adresse (zB: imap.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Einloggen",
        "PLACE_HOLDER": "Einloggen"
      },
      "PASSWORD": {
        "LABEL": "Passwort",
        "PLACE_HOLDER": "Passwort"
      },
      "ENABLE_SSL": "SSL aktivieren"
    },
    "MICROSOFT": {
      "TITLE": "Microsoft",
      "SUBTITLE": "MICROSOFT-Konto erneut autorisieren"
    },
    "SMTP": {
      "TITLE": "SMTP",
      "SUBTITLE": "Setzen Sie Ihre SMTP-Details",
      "UPDATE": "SMTP-Einstellungen aktualisieren",
      "TOGGLE_AVAILABILITY": "Die SMTP-Konfiguration für diesen Posteingang aktivieren",
      "TOGGLE_HELP": "Das Aktivieren von SMTP hilft dem Benutzer beim Senden von E-Mails",
      "EDIT": {
        "SUCCESS_MESSAGE": "SMTP-Einstellungen erfolgreich aktualisiert",
        "ERROR_MESSAGE": "SMTP-Einstellungen können nicht aktualisiert werden"
      },
      "ADDRESS": {
        "LABEL": "Adresse",
        "PLACE_HOLDER": "Adresse (zB: smtp.gmail.com)"
      },
      "PORT": {
        "LABEL": "Port",
        "PLACE_HOLDER": "Port"
      },
      "LOGIN": {
        "LABEL": "Einloggen",
        "PLACE_HOLDER": "Einloggen"
      },
      "PASSWORD": {
        "LABEL": "Passwort",
        "PLACE_HOLDER": "Passwort"
      },
      "DOMAIN": {
        "LABEL": "Domain",
        "PLACE_HOLDER": "Domain"
      },
      "ENCRYPTION": "Verschlüsselung",
      "SSL_TLS": "SSL/TLS",
      "START_TLS": "STARTTLS",
      "OPEN_SSL_VERIFY_MODE": "SSL-Überprüfungsmodus öffnen",
      "AUTH_MECHANISM": "Authentifizierung"
    },
    "EMAIL_DNS_CHECK": {
      "TITLE": "E-Mail-Zustellbarkeit (DNS)",
      "SUB_TITLE": "Wir prüfen die SPF-, DKIM-, DMARC- und MX-Einträge von {domain} an jedem Werktag. Wenn etwas dazu führt, dass empfangende Server Ihre Antworten ablehnen oder als Spam einstufen, erhalten Administratoren eine E-Mail mit der Lösung.",
      "RUN": "Prüfung starten",
      "RUN_SUCCESS": "DNS-Prüfung abgeschlossen",
      "RUN_ERROR": "Die DNS-Prüfung konnte nicht gestartet werden, bitte versuchen Sie es erneut",
      "NOT_CHECKED": "Noch nicht geprüft.",
      "CHECKED_AT": "Zuletzt geprüft: {time}.",
      "DNS_UNAVAILABLE": "Bei der letzten Prüfung haben die Nameserver der Domain nicht geantwortet. Das Ergebnis unten stammt von der vorherigen Prüfung.",
      "SENDER": {
        "SMTP": "Antworten werden über {host} versendet.",
        "PLATFORM": "Antworten werden über unsere Mailserver versendet."
      },
      "STATUS": {
        "OK": "Alle Einträge sind in Ordnung",
        "WARNING": "Einige Einträge könnten besser sein",
        "ERROR": "Antworten erreichen die Empfänger möglicherweise nicht",
        "UNKNOWN": "Unbekannt"
      },
      "SEVERITY": {
        "ERROR": "Problem",
        "WARNING": "Warnung"
      },
      "FIX": "Beheben Sie das Problem mit diesem DNS-Eintrag:",
      "RECORD_TYPE": "Typ",
      "RECORD_HOST": "Name",
      "RECORD_VALUE": "Wert",
      "ISSUES": {
        "spf_missing": {
          "TITLE": "SPF-Eintrag fehlt",
          "DESCRIPTION": "Die Domain gibt nicht an, welche Server E-Mails in ihrem Namen versenden dürfen. Viele Mailserver stufen Ihre Antworten dann als Spam ein. Fügen Sie einen SPF-Eintrag hinzu, der {sender} erlaubt."
        },
        "spf_multiple": {
          "TITLE": "Die Domain hat {count} SPF-Einträge",
          "DESCRIPTION": "Eine Domain darf nur einen SPF-Eintrag haben. Bei mehreren ignorieren empfangende Server SPF und lehnen E-Mails oft ab. Fassen Sie die Einträge zu einem zusammen."
        },
        "spf_not_authorized": {
          "TITLE": "SPF erlaubt den Server nicht, der Ihre Antworten versendet",
          "DESCRIPTION": "Ihre Antworten werden über {sender} versendet, aber der SPF-Eintrag der Domain führt ihn nicht auf. Aktueller Eintrag: {record}"
        },
        "spf_too_many_lookups": {
          "TITLE": "Der SPF-Eintrag benötigt zu viele DNS-Abfragen",
          "DESCRIPTION": "Empfangende Server beenden die SPF-Prüfung nach {limit} DNS-Abfragen, aber {sender}, der Ihre Antworten versendet, wird erst nach {lookups} erreicht. Ihre Antworten bestehen die SPF-Prüfung daher nicht. Setzen Sie {sender} an den Anfang des Eintrags und entfernen Sie include-Einträge, die die Domain nicht mehr verwendet."
        },
        "spf_lookups_others": {
          "TITLE": "Einige Absender im SPF-Eintrag liegen jenseits des Abfragelimits",
          "DESCRIPTION": "Der SPF-Eintrag benötigt {lookups} DNS-Abfragen, empfangende Server brechen nach {limit} ab. Ihre Antworten werden rechtzeitig erfasst und bestehen die Prüfung, aber E-Mails dieser Absender schlagen bei SPF fehl: {senders}. Entfernen Sie include-Einträge, die die Domain nicht mehr verwendet."
        },
        "spf_malformed": {
          "TITLE": "SPF-Eintrag ist fehlerhaft",
          "DESCRIPTION": "Empfangende Server können den SPF-Eintrag der Domain nicht lesen, er schützt Ihre Antworten daher nicht. Das Problem liegt in: {terms}. Ersetzen Sie den Eintrag durch den korrigierten."
        },
        "dkim_missing": {
          "TITLE": "DKIM-Signatur ist nicht eingerichtet",
          "DESCRIPTION": "Unter {selectors} haben wir keinen DKIM-Schlüssel gefunden. Ohne ihn werden Ihre Antworten nicht signiert und landen eher im Spam. Aktivieren Sie die DKIM-Signierung für die Domain bei Ihrem E-Mail-Anbieter."
        },
        "dmarc_missing": {
          "TITLE": "DMARC-Eintrag fehlt",
          "DESCRIPTION": "Große E-Mail-Anbieter wie Gmail und Microsoft erwarten einen DMARC-Eintrag. Ohne ihn landen Ihre Antworten eher im Spam."
        },
        "dmarc_fails": {
          "TITLE": "DMARC weist Empfänger an, Ihre Antworten abzulehnen",
          "DESCRIPTION": "Die DMARC-Richtlinie der Domain lautet „{policy}“, und Ihre Antworten bestehen weder die SPF- noch die DKIM-Prüfung. Empfänger lehnen sie deshalb ab oder verschieben sie in den Spam-Ordner. Beheben Sie zuerst SPF und DKIM weiter oben."
        },
        "dmarc_blocks_platform": {
          "TITLE": "DMARC blockiert Antworten, die über unsere Mailserver versendet werden",
          "DESCRIPTION": "Dieser Posteingang versendet Antworten über unsere Mailserver, aber die DMARC-Richtlinie der Domain lautet „{policy}“. Empfänger lehnen sie deshalb ab oder verschieben sie in den Spam-Ordner. Richten Sie für diesen Posteingang SMTP Ihres eigenen Mailservers ein."
        },
        "mx_missing": {
          "TITLE": "Die Domain hat keinen MX-Eintrag",
          "DESCRIPTION": "Ohne MX-Eintrag kann niemand E-Mails an die Domain senden, deshalb können Kunden nicht auf Ihre Antworten reagieren."
        }
      }
    },
    "NOTE": "Hinweis: ",
    "WIDGET_BUILDER": {
      "WIDGET_OPTIONS": {
        "AVATAR": {
          "LABEL": "Website-Avatar",
          "DELETE": {
            "API": {
              "SUCCESS_MESSAGE": "Avatar erfolgreich gelöscht",
              "ERROR_MESSAGE": "Es ist ein Fehler aufgetreten, bitte versuchen Sie es erneut"
            }
          }
        },
        "WEBSITE_NAME": {
          "LABEL": "Webseiten-Name",
          "PLACE_HOLDER": "Geben Sie den Namen Ihrer Website ein (zum Beispiel: Acme Inc)",
          "ERROR": "Bitte geben Sie einen gültigen Website-Namen ein"
        },
        "WELCOME_HEADING": {
          "LABEL": "Willkommens-Überschrift",
          "PLACE_HOLDER": "Hi!"
        },
        "WELCOME_TAGLINE": {
          "LABEL": "Willkommens-Schlagzeile",
          "PLACE_HOLDER": "Wir machen es einfach, sich mit uns zu verbinden. Fragen Sie uns etwas oder teilen Sie uns Ihr Feedback mit."
        },
        "REPLY_TIME": {
          "LABEL": "Antwortzeit",
          "IN_A_FEW_MINUTES": "Innerhalb weniger Minuten",
          "IN_A_FEW_HOURS": "Innerhalb weniger Stunden",
          "IN_A_DAY": "Innerhalb eines Tages"
        },
        "WIDGET_COLOR_LABEL": "Widget Farbe",
        "WIDGET_BUBBLE_POSITION_LABEL": "Position der Widget-Blase",
        "UNREAD_MESSAGES_MAX_HEIGHT": {
          "LABEL": "Maximale Höhe ungelesener Nachrichten (px)",
          "PLACE_HOLDER": "Keine Begrenzung",
          "HELP_TEXT": "Begrenzen Sie die maximale Höhe des Popups für ungelesene Nachrichten in Pixeln. Leer lassen für das Standardverhalten (keine Begrenzung)."
        },
        "WIDGET_BUBBLE_TYPE_LABEL": "Widget-Blasentyp",
        "WIDGET_BUBBLE_LAUNCHER_TITLE": {
          "DEFAULT": "Chatten Sie mit uns",
          "LABEL": "Widget Bubble Launcher-Titel",
          "PLACE_HOLDER": "Chatten Sie mit uns"
        },
        "UPDATE": {
          "BUTTON_TEXT": "Widget-Einstellungen aktualisieren",
          "API": {
            "SUCCESS_MESSAGE": "Widget-Einstellungen erfolgreich aktualisiert",
            "ERROR_MESSAGE": "Widget-Einstellungen können nicht aktualisiert werden"
          }
        },
        "WIDGET_VIEW_OPTION": {
          "PREVIEW": "Vorschau",
          "SCRIPT": "Script"
        },
        "WIDGET_BUBBLE_POSITION": {
          "LEFT": "Links",
          "RIGHT": "Rechts"
        },
        "WIDGET_BUBBLE_TYPE": {
          "STANDARD": "Standard",
          "EXPANDED_BUBBLE": "Erweiterte Blase"
        }
      },
      "WIDGET_SCREEN": {
        "DEFAULT": "Standard",
        "CHAT": "Chat"
      },
      "REPLY_TIME": {
        "IN_A_FEW_MINUTES": "Wir antworten üblicherweise innerhalb weniger Minuten",
        "IN_A_FEW_HOURS": "Wir antworten üblicherweise innerhalb weniger Stunden",
        "IN_A_DAY": "Wir antworten üblicherweise innerhalb eines Tages"
      },
      "FOOTER": {
        "START_CONVERSATION_BUTTON_TEXT": "Konversation beginnen",
        "CHAT_INPUT_PLACEHOLDER": "Schreiben Sie Ihre Nachricht"
      },
      "BODY": {
        "TEAM_AVAILABILITY": {
          "ONLINE": "Wir sind online",
          "OFFLINE": "Wir sind momentan abwesend"
        },
        "USER_MESSAGE": "Hi",
        "AGENT_MESSAGE": "Hallo"
      },
      "BRANDING_TEXT": "Unterstützt von JARABOT",
      "SCRIPT_SETTINGS": "\n      window.jarabotSettings = {options};"
    },
    "EMAIL_PROVIDERS": {
      "MICROSOFT": "Microsoft",
      "GOOGLE": "Google",
      "OTHER_PROVIDERS": "Andere Anbieter"
    },
    "CHANNELS": {
      "MESSENGER": "Messenger",
      "WEB_WIDGET": "Webseite",
      "TWITTER_PROFILE": "Twitter",
      "TWILIO_SMS": "Twilio SMS",
      "WHATSAPP": "WhatsApp",
      "SMS": "SMS",
      "EMAIL": "E-Mail",
      "TELEGRAM": "Telegramm",
      "LINE": "Line",
      "API": "API-Kanal",
      "SMS_BRANA": "SMS Brana",
      "DIDWW": "DIDWW",
      "PHONE": "SIP-Telefon",
      "INSTAGRAM": "Instagram",
      "SALESFORCE": "Salesforce",
      "ALLEGRO": "Allegro",
      "KAUFLAND": "Kaufland"
    },
    "SLA": {
      "TITLE": "SLA-Richtlinien",
      "SUB_TEXT": "Konfigurieren Sie SLA-Antwort- und Lösungszeiten für jede Unterhaltungspriorität.",
      "LOADING": "SLA-Richtlinien werden geladen...",
      "FIELDS": {
        "ACTIVE": "Aktiv",
        "TICKET_PRIORITY": "Ticket-Priorität",
        "FIRST_RESPONSE_TIME": "Erste Antwortzeit",
        "EVERY_RESPONSE_TIME": "Jede Antwortzeit",
        "RESOLUTION_TIME": "Lösungszeit",
        "PLACEHOLDER": "z. B. 1h 30m"
      },
      "API": {
        "SUCCESS_MESSAGE": "SLA-Richtlinien erfolgreich aktualisiert.",
        "ERROR_MESSAGE": "SLA-Richtlinien konnten nicht aktualisiert werden. Bitte versuchen Sie es erneut."
      }
    },
    "AUTOMATIC_PRIORITY": {
      "TITLE": "Automatische Priorität",
      "SUB_TEXT": "Konfigurieren Sie die automatische Prioritätszuweisung basierend auf dem Inhalt der Unterhaltung.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Abrechnungshinweis",
        "MESSAGE": "Jede Prioritätsauswertung wird berechnet. Bitte entnehmen Sie die Preisinformationen Ihren Plandetails."
      },
      "MODE": {
        "OFF": "Aus",
        "ALL_MESSAGES": "An für alle eingehenden Nachrichten",
        "FIRST_MESSAGE": "An nur für die erste eingehende Nachricht"
      },
      "PRIORITY_LEVELS": {
        "TITLE": "Konfiguration der Prioritätsstufen",
        "SUB_TEXT": "Konfigurieren Sie, welche Prioritätsstufen aktiviert werden sollen, und deren Beschreibungen. Geben Sie klare Kriterien an, damit die KI entscheiden kann, wann diese Priorität zugewiesen werden soll."
      },
      "DESCRIPTION_LABEL": "Beschreibung",
      "DESCRIPTION_PLACEHOLDER": "Unterhaltungen beschreiben, die als Priorität {priority} markiert werden sollen",
      "SET_AS_DEFAULT": "Als Standardpriorität festlegen",
      "MULTIPLE_DEFAULTS_WARNING": "Nur eine Prioritätsstufe sollte als Standard festgelegt werden. Bitte entfernen Sie die Markierung bei anderen Standards."
    },
    "AUTOMATIC_LABELING": {
      "TITLE": "Automatische Kennzeichnung",
      "SUB_TEXT": "Konfigurieren Sie die automatische Label-Zuweisung basierend auf dem Inhalt der Unterhaltung.",
      "BILLING_DISCLAIMER": {
        "TITLE": "Abrechnungshinweis",
        "MESSAGE": "Jede Auswertung zur Kennzeichnung wird berechnet. Bitte entnehmen Sie die Preisinformationen Ihren Plandetails."
      },
      "MODE": {
        "OFF": "Aus",
        "CONVERSATION_OPEN": "Beim Öffnen der Unterhaltung",
        "CONVERSATION_CLOSE": "Beim Schließen der Unterhaltung",
        "ALL_MESSAGES": "Bei jeder Nachricht – unabhängig vom Status",
        "FIRST_MESSAGE": "Bei der ersten Nachricht – unabhängig vom Status"
      },
      "LABEL_CONFIGURATION": {
        "TITLE": "Label-Konfiguration",
        "SUB_TEXT": "Konfigurieren Sie, welche Labels für die automatische Zuweisung verfügbar sein sollen, und deren Beschreibungen. Geben Sie klare Kriterien an, damit die KI entscheiden kann, wann dieses Label angewendet werden soll."
      },
      "DESCRIPTION_LABEL": "Beschreibung",
      "DESCRIPTION_PLACEHOLDER": "Unterhaltungen beschreiben, die als {label} gekennzeichnet werden sollen. Wenn Sie dieses Feld leer lassen, wird die Label-Beschreibung verwendet.",
      "NO_LABELS_MESSAGE": "Keine Labels gefunden. Erstellen Sie zuerst Labels, um die automatische Kennzeichnung zu aktivieren.",
      "CREATE_LABELS_LINK": "Labels erstellen"
    },
    "PHONE": {
      "TITLE": "Telefoneinstellungen",
      "SUBTITLE": "Legen Sie fest, welche Anrufe in diesem Posteingang angezeigt werden.",
      "UPDATE": "Einstellungen speichern",
      "EDIT": {
        "SUCCESS_MESSAGE": "Telefoneinstellungen aktualisiert",
        "ERROR_MESSAGE": "Telefoneinstellungen konnten nicht aktualisiert werden"
      },
      "PHONE_NUMBERS": {
        "LABEL": "Telefonnummern",
        "SUBTITLE": "Geben Sie Telefonnummern ein, die zu diesem Posteingang gehören.",
        "PLACEHOLDER": "+145123908635",
        "ADD": "Telefonnummer hinzufügen"
      }
    }
  }
}
